import { render, staticRenderFns } from "./ProgressFooter.vue?vue&type=template&id=af2a288c&lang=pug&"
import script from "./ProgressFooter.vue?vue&type=script&lang=ts&"
export * from "./ProgressFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports